<div class="flex flex-col gap-2.5" [ngClass]="tierClass">
	<div class="flex items-center gap-3">
		<span class="pct-pill inline-flex items-center justify-center min-w-[48px] px-3 py-1.5 rounded-full text-xs font-bold font-sans tabular-nums">
			<ng-container *ngIf="!item.unlimited; else infPill">{{ displayPercentage | number : '1.0-2' }}%</ng-container>
			<ng-template #infPill>∞</ng-template>
		</span>

		<span class="font-serif font-bold text-[18px] leading-tight text-primary">
			<ng-container *ngIf="useRawFeatureName; else translatedLabel">
				{{ item.feature_name }}
			</ng-container>
			<ng-template #translatedLabel>
				{{ (labelKey ?? (item.key | featureKeyLabel)) | translate }}
			</ng-template>
		</span>

		<span class="ml-auto font-bold text-[15px] tabular-nums text-primary whitespace-nowrap">
			<ng-container *ngIf="isStorage">
				{{ item.used | filesize }}
				<span class="text-[var(--cockpit-muted)] font-medium">/</span>
				<ng-container *ngIf="!item.unlimited; else infLimit">{{ item.limit | filesize }}</ng-container>
			</ng-container>

			<ng-container *ngIf="!isStorage && isDuration">
				{{ item.used | duration : (isEncodingMinutes ? 'minutes' : 'short') }}
				<span class="text-[var(--cockpit-muted)] font-medium">/</span>
				<ng-container *ngIf="!item.unlimited; else infLimitMin">
					{{ item.limit | duration : (isEncodingMinutes ? 'minutes' : 'short') }}
				</ng-container>
				<ng-template #infLimitMin>
					∞ {{ isEncodingMinutes ? ('VIEWS.USER_BOARD.COCKPIT.COCKPIT_UNIT_MIN' | translate) : '' }}
				</ng-template>
			</ng-container>

			<ng-container *ngIf="!isStorage && !isDuration">
				{{ item.used | number }}
				<span class="text-[var(--cockpit-muted)] font-medium">/</span>
				<ng-container *ngIf="!item.unlimited; else infCount">{{ item.limit | number }}</ng-container>
				<ng-template #infCount>∞</ng-template>
			</ng-container>

			<ng-template #infLimit>∞</ng-template>
		</span>
	</div>

	<div class="bar w-full h-2.5 rounded-full overflow-hidden bg-[var(--cockpit-green-mint)] relative">
		<span class="bar-fill block h-full rounded-full transition-[width] duration-[600ms] ease-out"
			[style.width.%]="item.unlimited ? 100 : displayPercentage"></span>
	</div>

	<div class="text-[12.5px] text-[var(--cockpit-muted)]">
		<ng-container *ngIf="!item.unlimited; else infRemain">
			<ng-container *ngIf="isStorage">{{ item.remaining | filesize }}</ng-container>
			<ng-container *ngIf="!isStorage && isDuration">{{ item.remaining | duration : (isEncodingMinutes ? 'minutes' : 'short') }}</ng-container>
			<ng-container *ngIf="!isStorage && !isDuration">{{ item.remaining | number }}</ng-container>
			{{ 'VIEWS.USER_BOARD.COCKPIT.REMAINING_SUFFIX' | translate }}
		</ng-container>
		<ng-template #infRemain>
			{{ 'VIEWS.USER_BOARD.COCKPIT.UNLIMITED' | translate }}
		</ng-template>
	</div>
</div>
